// Global Init
const { 
    OverlayScrollbars, 
    ScrollbarsHidingPlugin, 
    SizeObserverPlugin, 
    ClickScrollPlugin  
} = OverlayScrollbarsGlobal;

// Tab Settings
const allCatStudyNavs = document.querySelectorAll('.js-study-categories')
allCatStudyNavs.forEach(studyNav => {
    // Study Categories - Scrollbar
    OverlayScrollbars(studyNav, {
        overflow: {
            x: 'scroll',
            y: 'hidden',
        },
    })

    studyNav.addEventListener('click', e => {
        const clickedSlide = e.target
        const study = clickedSlide.dataset.study
        const allButtons = studyNav.querySelectorAll('.js-scientific-study-tab')
        const container = clickedSlide.closest('.js-scientific-studies')

        // Remove "is_active" on all buttons
        allButtons.forEach(btn => {
            if (btn.classList.contains('is_active')) {
                btn.classList.remove('is_active')
            }
        });

        // Add "is_active" to clicked slide
        if (clickedSlide.classList.contains('is_active') === false) {
            clickedSlide.classList.add('is_active')
        }

        // Hide all scientific study sliders
        const allScientificStudySliders = container.querySelectorAll('.js-scientific-study_wrapper')
        allScientificStudySliders.forEach(scientificStudySlider => {
            scientificStudySlider.style.display = "none";
        });

         // Show relevant scientific study
        container.querySelector(`#${study}`).style.display = "block";
    })
});

// Open all study links in new tabs
const studyDescriptions = document.querySelectorAll('.js-studies-text')
studyDescriptions.forEach(description => {
    
    description.addEventListener('click', e => {
        e.preventDefault()
        const link = e.target.closest('a')
        if (link !== null) {
            const url = link.href
            window.open(url, '_blank').focus();
        }
    })
});

// Slider without Headings or Tabs
const noHeadingSwiper = new Swiper('.NoHeadingSwiper', {
    loop: true,
    autoHeight: true,
    disableOnInteraction: false, 
    slidesPerView: 1,
    spaceBetween: 10,
    pagination: {
        el: '.NoHeadingSwiper__swiper-pagination',
        type: 'bullets', 
        clickable: true,
    },
    navigation: {
        nextEl: ".js-next__NoHeadingSwiper",
        prevEl: ".js-prev__NoHeadingSwiper",
    },
});

// Slider without categories
const noCatSwiper = new Swiper('.js-scientific-studies-sliders', {
    loop: true,
    autoHeight: true,
    disableOnInteraction: false, 
    slidesPerView: 1,
    spaceBetween: 10,
    pagination: {
        el: '.js-all-sliders__swiper-pagination',
        type: 'bullets', 
        clickable: true,
    },
    navigation: {
        nextEl: ".js-next__scientific-studies",
        prevEl: ".js-prev__scientific-studies",
    },
});

// Sliders with Headings or Tabs
const allScientificStudyTabs = document.querySelectorAll('.js-scientific-studies-tabs')
allScientificStudyTabs.forEach(slider => {
    const handle = slider.dataset.sliderHandle
    const sliderClass = slider.dataset.sliderClass 

    const swiper = new Swiper(`.${sliderClass}`, {
        loop: true,
        autoHeight: true,
        disableOnInteraction: false, 
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
            el: `.${handle}__swiper-pagination`,
            type: 'bullets', 
            clickable: true,
        },
        navigation: {
            nextEl: `.js-next__${handle}`,
            prevEl: `.js-prev__${handle}`,
        },
    });

});
